module.exports = __webpack_public_path__ + "img/0.20bcd8c5.svg";